<template>
  <div>
    <b-card header-tag="header" class="card-options mt-1">
      <template #header>
        <div class="d-flex justify-content-center align-items-center">
          <h4 class="flex-grow-1 text-center m-0">
            {{ $t("reusable.aiComponent.options") }}
          </h4>
          <b-icon
            icon="gear-fill"
            class="ml-auto icon-settings"
            @click="advancedSettings"
            v-b-tooltip.v-secondary.noninteractive="
              $t('reusable.aiComponent.advancedOptions')
            "
          ></b-icon>
        </div>
      </template>

      <b-card-body
        class="body-card-container"
        :class="{
          'custom-card-height': sub_option == 2 || sub_option == 3,
        }"
      >
        <!-- PASO 1: Agregar Selector -->
        <!-- SELECTOR 1: Tipo de Opción -->
        <GenericSelector
          :title="$t('reusable.aiComponent.whatToCreate')"
          :options="intelligenceOptions"
          reduceKey="id"
          v-model="selected_intelligence_option"
          labelKey="label"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_intelligence_option &&
            selected_intelligence_option != null
          "
          @change="clearInfoSelector"
        ></GenericSelector>

        <!-- SELECTOR 2: Perfil de Egreso  -->
        <GenericSelector
          v-if="[1, 2, 3, 4, 5, 6].includes(selected_intelligence_option)"
          :title="`${$t('reusable.aiComponent.selectEntity', {
            article: 'un',
            entity: $getVisibleNames(
              'mesh.egressprofile',
              false,
              'Perfil de Egreso'
            ),
          })}`"
          :options="egress_profiles"
          reduceKey="id"
          v-model="selected_egress_profile"
          labelKey="name"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_egress_profile && selected_egress_profile != null
          "
          @change="fetchEgressProfile"
        ></GenericSelector>

        <!-- SELECTOR 3: Asignatura  -->
        <GenericSelector
          v-if="[2, 3, 4, 5, 6].includes(selected_intelligence_option)"
          :title="`${$t('reusable.aiComponent.selectEntity', {
            article: 'una',
            entity: $getVisibleNames(
              'mesh.egressprofilematter',
              false,
              'Asignatura'
            ),
          })}`"
          :options="egressProfileMatterOptions"
          reduceKey="id"
          v-model="selected_egress_profile_matter"
          labelKey="label"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_egress_profile_matter &&
            selected_egress_profile_matter != null
          "
          @change="fetchStudyUnit"
        ></GenericSelector>

        <!-- SELECTOR 4: Unidad de Competencia  -->
        <GenericSelector
          v-if="
            [2, 3].includes(selected_intelligence_option) &&
            institution &&
            institution.show_competence_unit
          "
          :title="`${$t('reusable.aiComponent.selectEntity', {
            article: 'una',
            entity: $getVisibleNames(
              'teaching.tempcompetenceunit',
              false,
              'Unidad de competencia'
            ),
          })}`"
          :options="competenceUnitOptions"
          reduceKey="id"
          v-model="selected_competence_unit"
          labelKey="display_label"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_competence_unit &&
            selected_competence_unit != null
          "
        ></GenericSelector>

        <!-- SELECTOR 5: RA  -->
        <GenericSelector
          v-if="
            [3].includes(selected_intelligence_option) ||
            ([8].includes(selected_intelligence_option) && sub_option == 4)
          "
          :title="`${$t('reusable.aiComponent.selectEntity', {
            article: 'un',
            entity: $getVisibleNames('teaching.ramicro', false, 'RA Micro'),
          })}`"
          :options="studyUnitOptions"
          reduceKey="id"
          v-model="selected_study_unit"
          labelKey="full_sentence"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_study_unit && selected_study_unit != null
          "
        ></GenericSelector>

        <!-- SELECTOR 6: Dimensión (IE) seleccionada del Nivel de Logro  -->
        <GenericSelector
          v-if="[8].includes(selected_intelligence_option) && sub_option == 1"
          :title="`${$t('reusable.aiComponent.selectedEntity', {
            entity: $getVisibleNames('manual.dimension', false, 'Dimensión'),
          })}`"
          :options="rubricCriteriaOptions"
          reduceKey="id"
          v-model="selected_rubric_criteria"
          labelKey="full_sentence"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_rubric_criteria &&
            selected_rubric_criteria != null
          "
        ></GenericSelector>

        <!-- SELECTOR 7: Nivel de Logro  -->
        <GenericSelector
          v-if="[8].includes(selected_intelligence_option) && sub_option == 1"
          :title="`${$t('reusable.aiComponent.selectedEntity', {
            entity: $getVisibleNames(
              'evaluations2.rubricperformancelevel',
              false,
              'Nivel de Logro'
            ),
          })}`"
          :options="rubricAchievementOptions"
          reduceKey="id"
          v-model="selected_rubric_achievement"
          labelKey="title"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_rubric_achievement &&
            selected_rubric_achievement != null
          "
        ></GenericSelector>

        <!-- SELECTOR 8: Dimension Crear / Editar  -->
        <GenericSelector
          v-if="[8].includes(selected_intelligence_option) && sub_option == 2"
          :title="`${$t('reusable.aiComponent.selectEntity', {
            article: 'un',
            entity: $getVisibleNames(
              'teaching.evaluationcriteriamicro',
              false,
              'Criterio de Evaluación Micro'
            ),
          })}`"
          :options="evaluationCriteriaMicroOptions"
          reduceKey="id"
          v-model="selected_evaluation_criteria_micro"
          labelKey="full_sentence"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_evaluation_criteria_micro &&
            selected_evaluation_criteria_micro != null
          "
        ></GenericSelector>

        <!-- SELECTOR 9: Pregunta  -->
        <GenericSelector
          v-if="[8].includes(selected_intelligence_option) && sub_option == 3"
          :title="`${$t('reusable.aiComponent.selectEntity', {
            article: 'un',
            entity: $getVisibleNames(
              'teaching.evaluationcriteriamicro',
              false,
              'Criterio de Evaluación Micro'
            ),
          })}`"
          :options="evaluationCriteriaMicroOptions"
          reduceKey="id"
          v-model="selected_evaluation_criteria_micro"
          labelKey="full_sentence"
          trackByKey="id"
          :placeholder="$t('reusable.aiComponent.selectOption')"
          :disabled="
            disabled_selected_evaluation_criteria_micro &&
            selected_evaluation_criteria_micro != null
          "
        ></GenericSelector>

        <!-- SELECTOR 10: Recursos Bibliograficos  -->
        <GenericSelector
          v-if="[8].includes(selected_intelligence_option) && sub_option == 6"
          :title="$t('reusable.aiComponent.selectType')"
          :options="bibliographicResourceTypesOptions"
          reduceKey="id"
          v-model="selected_bibliographic_resources"
          labelKey="name"
          trackByKey="id"
          :placeholder="`-- ${$t('reusable.aiComponent.selectType')} --`"
          :disabled="
            disabled_selected_bibliographic_resources &&
            selected_bibliographic_resources != null
          "
        ></GenericSelector>

        <!-- SELECTOR 11: Tipo APA  -->
        <GenericSelector
          v-if="[8].includes(selected_intelligence_option) && sub_option == 6"
          :title="$t('reusable.aiComponent.selectFormat')"
          :options="bibliographicFormatOptions"
          reduceKey="id"
          v-model="selected_bibliographic_format"
          labelKey="name"
          trackByKey="id"
          :placeholder="`-- ${$t(
            'reusable.aiComponent.selectFormatPlaceholder'
          )} --`"
          :disabled="
            disabled_selected_bibliographic_format &&
            selected_bibliographic_format != null
          "
        ></GenericSelector>

        <!-- Matriz 1 Mensaje -->
        <div
          v-if="[8].includes(selected_intelligence_option) && sub_option == 5"
          class="mb-3"
        >
          <span
            >{{ $t("reusable.aiComponent.willBeConsidered") }}
            {{ $getVisibleNames("mesh.competence", false, "Competencia") }}
            <strong>
              {{ order_last_cycle }}.{{ order_last_competence }}
            </strong>
            {{ $t("reusable.aiComponent.toGenerate") }}
            {{ $getVisibleNames("mesh.competence", false, "Competencia") }}
            {{ $t("reusable.aiComponent.from") }}
            {{ $getVisibleNames("mesh.cycle", false, "Ciclo Formativo") }}
            "{{ name_cycle_actual }}"
          </span>
        </div>

        <!-- Texto Libre -->
        <div
          v-if="
            [7].includes(selected_intelligence_option) ||
            ([8].includes(selected_intelligence_option) && sub_option == 3)
          "
          class="mb-3"
        >
          <div
            v-if="!show_message_evaluation_view"
            class="mb-3 text-left pre-text-area"
          >
            <span v-if="egressProfile">
              "{{ $t("reusable.aiComponent.fromThe") }}
              {{
                $getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de Egreso"
                )
              }}
              {{ egressProfile.professional_title }}
              <span v-if="egressProfileMatter">
                {{ $t("reusable.aiComponent.andThe") }}
                {{
                  $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  )
                }}
                {{ egressProfileMatterTrim }} </span
              >, {{ $t("reusable.aiComponent.generates") }}
              {{ selected_example_amount }}
              <span v-if="selected_example_amount == 1">
                {{ $t("reusable.aiComponent.example") }}
              </span>
              <span v-else>
                {{ $t("reusable.aiComponent.examples") }}
              </span>
              {{ $t("reusable.aiComponent.of")
              }}<span v-if="sub_option == 3">
                {{ $t("reusable.aiComponent.question")
                }}{{ selected_example_amount == 1 ? "" : "s" }} </span
              >..."
            </span>
          </div>
          <div
            v-if="matter && show_message_evaluation_view"
            class="mb-3 text-left pre-text-area"
          >
            "{{ $t("reusable.aiComponent.forThe") }}
            {{
              $getVisibleNames("evaluations2.evaluation", false, "Evaluación")
            }}
            {{ $t("reusable.aiComponent.of") }}
            {{
              $getVisibleNames("mesh.egressprofilematter", false, "Asignatura")
            }}
            {{ matterTrim }},
            {{ $t("reusable.aiComponent.generates") }}
            {{ selected_example_amount }}
            <span v-if="selected_example_amount == 1">
              {{ $t("reusable.aiComponent.example") }}
            </span>
            <span v-else>
              {{ $t("reusable.aiComponent.examples") }}
            </span>
            {{ $t("reusable.aiComponent.of2") }}
            <span v-if="sub_option == 3">
              {{ $t("reusable.aiComponent.question")
              }}{{ selected_example_amount == 1 ? "" : "s" }} </span
            >..."
          </div>

          <b-form-textarea
            id="text_area"
            v-model="text_area"
            :placeholder="$t('reusable.aiComponent.writeAdditionalContext')"
            rows="5"
            max-rows="6"
            maxlength="300"
          ></b-form-textarea>
          <div class="text-right">
            <span style="font-size: 11pt">
              {{ $t("reusable.aiComponent.availableCharacters") }}:
              <strong>{{ max_length - text_area.length }}</strong>
            </span>
          </div>
        </div>

        <!-- Cantidad de Ejemplos-->
        <div class="mt-0 text-left">
          <span>
            {{ $t("reusable.aiComponent.selectAmountExamples") }}
          </span>
          <div class="container-checkbox-amount mt-1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="selected_example_amount"
              :value="1"
              @change="updateTokens"
              :disabled="selected_example_amount == 1"
            >
              1
            </b-form-checkbox>
            <b-form-checkbox
              id="checkbox-2"
              v-model="selected_example_amount"
              :value="2"
              @change="updateTokens"
              :disabled="selected_example_amount == 2"
            >
              2
            </b-form-checkbox>
            <b-form-checkbox
              id="checkbox-3"
              v-model="selected_example_amount"
              :value="3"
              @change="updateTokens"
              :disabled="selected_example_amount == 3"
            >
              3
            </b-form-checkbox>
            <b-form-checkbox
              id="checkbox-4"
              v-model="selected_example_amount"
              :value="4"
              @change="updateTokens"
              :disabled="selected_example_amount == 4"
            >
              4
            </b-form-checkbox>
            <b-form-checkbox
              id="checkbox-5"
              v-model="selected_example_amount"
              :value="5"
              @change="updateTokens"
              :disabled="selected_example_amount == 5"
            >
              5
            </b-form-checkbox>
          </div>
        </div>
      </b-card-body>

      <!-- Botón de Generar Ejemplos (FOOTER)-->
      <b-card-footer>
        <ButtonMedium
          v-if="
            disabledButtonGenerateExamples ||
            (user && user.user_data && !user.user_data.ai_component)
          "
          :tooltip_text="``"
          :text_button="$t('reusable.aiComponent.generateExamples')"
          :icon="''"
          :variant="'primary'"
          :custom_class="``"
          :disabled_button="true"
        >
        </ButtonMedium>
        <ButtonMedium
          v-else
          :tooltip_text="``"
          :text_button="$t('reusable.aiComponent.generateExamples')"
          :click_button="generateExamples"
          :icon="''"
          :variant="'primary'"
          :custom_class="``"
          :disabled_button="disabled_button_generate == true"
        >
        </ButtonMedium>
      </b-card-footer>
    </b-card>
    <AdvancedOptions
      v-if="advanced_settings"
      :advanced_settings="advanced_settings"
      :temperature_value.sync="temperature_value"
      :tokens_value.sync="tokens_value"
      @close="advanced_settings = false"
    ></AdvancedOptions>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";
import { URL } from "@/utils/globals";

export default {
  name: "FirstTab",
  components: {
    GenericSelector: () =>
      import("@/components/reusable/ai-component/GenericSelector"),
    AdvancedOptions: () =>
      import("@/components/reusable/ai-component/AdvancedOptions"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  props: {},
  data() {
    return {
      // PASO 2: Agregar variables del selector
      // Variables de los Selectores
      selected_intelligence_option: null,
      selected_egress_profile: null,
      selected_egress_profile_matter: null,
      selected_competence_unit: null,
      selected_study_unit: null,
      selected_rubric_criteria: null,
      selected_rubric_achievement: null,
      selected_evaluation_criteria_micro: null,
      selected_bibliographic_resources: null,
      selected_bibliographic_format: null,
      selected_competence: null,
      selected_cycle: null,
      disabled_selected_intelligence_option: false,
      disabled_selected_egress_profile: false,
      disabled_selected_egress_profile_matter: false,
      disabled_selected_competence_unit: false,
      disabled_selected_study_unit: false,
      disabled_selected_rubric_criteria: false,
      disabled_selected_rubric_achievement: false,
      disabled_selected_evaluation_criteria_micro: false,
      disabled_selected_bibliographic_resources: false,
      disabled_selected_bibliographic_format: false,
      disabled_text_area: false,
      // Variables generales
      selected_example_amount: 3,
      disabled_button_generate: false, // Variable para deshabilitar boton cuando se genera un ejemplo
      advanced_settings: false, // Variable para visualizar "Opciones Avanzadas"
      sub_option: 0, // Variable para reutilizar opción 8 en distintos casos
      available_evaluation_criteria_micro: [],
      matter_id: null,
      text_area: "",
      extra_context: "",
      extra_label: "", // Variable para dar nombre personalizado a la opcion de (intelligence_options)
      max_length: 600, // Variable para mostrar cantidad de caracteres usados en el text-area
      show_message_evaluation_view: false, // Variable para mostrar mensaje desde evaluation_view
      parameter_local_storage: false,
      name_cycle_actual: "",
      order_last_competence: 0,
      order_last_cycle: 0,
      // Variables de Opciones Avanzadas
      temperature_value: 0.5,
      tokens_value: 300,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      filter_intelligence: names.FILTER_INTELLIGENCE,
      intelligence_options: names.INTELLIGENCE_OPTIONS,
      egress_profiles: names.EGRESS_PROFILES,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      competence_units: names.COMPETENCE_UNITS,
      study_units: names.STUDY_UNITS,
      matters: names.MATTERS,
      rules_filter_selector: names.RULES_FILTER_SELECTOR,
      rubric_criterias: names.NEW_RUBRIC_CRITERIAS,
      rubric_achievements: names.NEW_RUBRIC_ACHIEVEMENTS,
      evaluation_criteria_micros: names.EVALUATION_CRITERIAS,
      competences: names.COMPETENCES,
      cycles: names.CYCLES,
      bibliographic_resources_types: names.BIBLIOGRAPHIC_RESOURCE_TYPES,
    }),
    intelligenceOptions() {
      let list = this.intelligence_options
        .filter((x) => {
          // Siempre excluye el id 4, excepto en el caso de "ipss.cl"
          if (
            x.id == 4 &&
            !(this.institution && this.institution.show_competence_unit)
          ) {
            return false;
          }
          // Incluye id 5 solo si show_ra_macro es true
          if (x.id == 5) {
            return this.institution && this.institution.show_ra_macro == true;
          }
          // Incluye id 6 solo si show_evaluation_criteria_macro es true
          if (x.id == 6) {
            return (
              this.institution &&
              this.institution.show_evaluation_criteria_macro == true
            );
          }
          // Incluye todos los demás ids
          return true;
        })
        .map((x) => {
          let labelOption = false;

          // Si el N° de ejemplos es 1 se coloca en singular
          if (this.selected_example_amount == 1) {
            labelOption = false;
          }
          // Si el N° de ejemplos es 2 3 4 o 5 se coloca en plural
          else if (
            this.selected_example_amount == 2 ||
            this.selected_example_amount == 3 ||
            this.selected_example_amount == 4 ||
            this.selected_example_amount == 5
          ) {
            labelOption = true;
          }
          return {
            ...x,
            label:
              this.$getVisibleNames(x.app_models, labelOption, x.label_text) +
              this.extra_label,
          };
        });
      // Aplica el filtro adicional si está configurado
      if (
        this.rules_filter_selector &&
        this.rules_filter_selector.visible_intelligence_options &&
        this.rules_filter_selector.visible_intelligence_options.length > 0
      ) {
        list = list.filter((x) =>
          this.rules_filter_selector.visible_intelligence_options.includes(x.id)
        );
      }
      return list;
    },
    // PASO 3: Agregar Opciones del Selector
    egressProfileMatterOptions() {
      let list = [];
      if (this.selected_egress_profile == null) return [];
      list = [
        ...this.egress_profile_matters.filter(
          (x) => x.egress_profile == this.selected_egress_profile
        ),
      ];
      list.forEach((x) => {
        const matter = this.matters.find((matter) => matter.id == x.matter);
        if (matter) {
          x.label = String(matter.code + " - " + matter.name);
          x.name = matter.name;
        } else {
          x.label = "";
          x.name = "";
        }
      });
      return list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
    },
    competenceUnitOptions() {
      let list = [];
      if (this.selected_egress_profile_matter == null) return [];
      const matter = this.egress_profile_matters.find(
        (x) => x.id == this.selected_egress_profile_matter
      );
      if (matter) {
        list = this.competence_units
          .filter((x) => x.matter == matter.matter)
          .map((x) => ({
            ...x,
            display_label: x.full_sentence || x.name,
          }));
      }
      return list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
    },
    studyUnitOptions() {
      let list = [];
      if (this.selected_egress_profile_matter == null) return [];
      const matter = this.egress_profile_matters.find(
        (x) => x.id == this.selected_egress_profile_matter
      );
      if (matter) {
        list = this.study_units.filter((x) => x.matter == matter.matter);
      }
      return list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
    },
    rubricCriteriaOptions() {
      let list = [];
      if (this.selected_rubric_criteria == null) return [];
      list = this.rubric_criterias.filter(
        (x) => x.id == this.selected_rubric_criteria
      );
      return list;
    },
    competenceOptions() {
      let list = [];
      if (this.selected_competence == null) return [];
      list = this.competences.filter((x) => x.id == this.selected_competence);
      return list;
    },
    cycleOptions() {
      let list = [];
      if (this.selected_cycle == null) return [];
      list = this.cycles.filter((x) => x.id == this.selected_cycle);
      return list;
    },
    rubricAchievementOptions() {
      let list = [];
      if (this.selected_rubric_achievement == null) return [];
      list = this.rubric_achievements.filter(
        (x) => x.id == this.selected_rubric_achievement
      );
      return list;
    },
    evaluationCriteriaMicroOptions() {
      let list = [];
      if (this.available_evaluation_criteria_micro.length == 0) return [];
      list = this.evaluation_criteria_micros.filter((x) =>
        this.available_evaluation_criteria_micro.includes(x.id)
      );
      return list.sort((a, b) =>
        a.full_sentence.localeCompare(b.full_sentence)
      );
    },
    bibliographicResourceTypesOptions() {
      return this.bibliographic_resources_types.map((type) => ({
        id: type.id,
        name: type.name,
      }));
    },
    bibliographicFormatOptions() {
      return [
        { id: 1, name: "APA 7ª ed." },
        { id: 2, name: "APA 6ª ed." },
      ];
    },
    egressProfile() {
      if (!this.selected_egress_profile) return null;
      return this.egress_profiles.find(
        (x) => x.id == this.selected_egress_profile
      );
    },
    egressProfileMatter() {
      if (!this.selected_egress_profile_matter) return null;
      return this.egressProfileMatterOptions.find(
        (x) => x.id == this.selected_egress_profile_matter
      );
    },
    matter() {
      return this.matters.find((x) => x.id == this.matter_id);
    },
    matterTrim() {
      if (!this.matter) return "";
      return this.matter.name.trim();
    },
    egressProfileMatterTrim() {
      if (!this.egressProfileMatter) return "";
      return this.egressProfileMatter.name.trim();
    },
    // PASO 4 Agregar condiciones para deshabilitar el Botón
    disabledButtonGenerateExamples() {
      // Opción generar Competencia
      if (
        this.selected_intelligence_option == 1 &&
        this.selected_egress_profile == null
      ) {
        return true;
      }
      // Opción generar Unidad de Estudio
      if (
        this.institution &&
        this.institution.internal_use_id != "duoc.cl" &&
        this.institution.show_competence_unit == false &&
        this.selected_intelligence_option == 2 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null)
      ) {
        return true;
      }
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.selected_intelligence_option == 2 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null)
      ) {
        return true;
      }
      if (
        this.institution &&
        this.institution.show_competence_unit &&
        this.selected_intelligence_option == 2 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null ||
          this.selected_competence_unit == null)
      ) {
        return true;
      }

      // Opción generar Indicador de Logro
      if (
        this.institution &&
        this.institution.internal_use_id != "duoc.cl" &&
        this.institution.show_competence_unit == false &&
        this.selected_intelligence_option == 3 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null ||
          this.selected_study_unit == null)
      ) {
        return true;
      }
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.selected_intelligence_option == 3 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null ||
          this.selected_study_unit == null)
      ) {
        return true;
      }
      if (
        this.institution &&
        this.institution.show_competence_unit &&
        this.selected_intelligence_option == 3 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null ||
          this.selected_study_unit == null ||
          this.selected_competence_unit == null)
      ) {
        return true;
      }

      // Opción generar Unidad de Competencia (IPSS)
      if (
        this.selected_intelligence_option == 4 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null)
      ) {
        return true;
      }
      // Opción generar RA Macro
      if (
        this.selected_intelligence_option == 5 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null)
      ) {
        return true;
      }
      // Opción generar Evaluation Criteria Macro
      if (
        this.selected_intelligence_option == 6 &&
        (this.selected_egress_profile == null ||
          this.selected_egress_profile_matter == null)
      ) {
        return true;
      }
      // Opción Texto Libre
      if (
        this.selected_intelligence_option == 7 &&
        (this.text_area == null || this.text_area == "")
      ) {
        return true;
      }
      // Opción 8 Generica
      if (this.selected_intelligence_option == 8) {
        if (
          // Sub_Option == 1 Niveles de Logro
          (this.sub_option == 1 &&
            (this.selected_rubric_criteria == null ||
              this.selected_rubric_achievement == null)) ||
          // Sub_Option == 2 Dimension
          (this.sub_option == 2 &&
            this.selected_evaluation_criteria_micro == null) ||
          // Sub_Option == 3 Preguntas
          (this.sub_option == 3 &&
            (this.selected_evaluation_criteria_micro == null ||
              this.text_area == null ||
              this.text_area == "")) ||
          // Sub_Option == 4 Contenidos
          (this.sub_option == 4 && this.selected_study_unit == null) ||
          // Sub_Option == 5 Competencias por ciclos
          (this.sub_option == 5 && this.selected_intelligence_option == null) ||
          // Sub_Option == 6 Recursos Bibliograficos
          (this.sub_option == 6 &&
            (this.selected_bibliographic_resources == null ||
              this.selected_bibliographic_format == null))
        )
          return true;
      }
      return false;
    },
  },
  methods: {
    advancedSettings() {
      this.advanced_settings = !this.advanced_settings;
    },
    // PASO 5: Agregar Prompt si la nueva opcion contiene una sub_option
    promptRubricAchievement() {
      if (this.sub_option == 1) {
        let rubric_achiev = this.rubric_achievements.find(
          (x) => x.id == this.selected_rubric_achievement
        );
        let rubric_crit = this.rubric_criterias.find(
          (x) => x.id == this.selected_rubric_criteria
        );
        if (rubric_achiev && rubric_crit) {
          return this.$t("reusable.aiComponent.dimensionLevelPrompt", {
            dimensionEntity: this.$getVisibleNames(
              "manual.dimension",
              false,
              "Dimensión"
            ),
            dimension: rubric_crit.full_sentence,
            levelEntity: this.$getVisibleNames(
              "evaluations2.rubricperformancelevel",
              false,
              "Nivel de Logro"
            ),
            level: rubric_achiev.title,
          });
        } else return null;
      }
      if (this.sub_option == 2) {
        let eva_crit_micro = this.evaluation_criteria_micros.find(
          (x) => x.id == this.selected_evaluation_criteria_micro
        );
        if (eva_crit_micro) {
          const indicadorText =
            this.selected_example_amount == 1
              ? this.$t("reusable.aiComponent.evaluationIndicator", {
                  entity: this.$getVisibleNames(
                    "teaching.evaluationcriteriamicro",
                    false,
                    "indicador de evaluación"
                  ),
                })
              : this.$t("reusable.aiComponent.evaluationIndicators", {
                  entity: this.$getVisibleNames(
                    "teaching.evaluationcriteriamicro",
                    true,
                    "indicadores de evaluación"
                  ),
                });
          return this.$t("reusable.aiComponent.dimensionCriteriaPrompt", {
            indicatorEntity: this.$getVisibleNames(
              "teaching.evaluationcriteriamicro",
              false,
              "Indicador de Logro"
            ),
            indicator: eva_crit_micro.full_sentence,
            text: indicadorText,
          });
        }
      }
      if (this.sub_option == 3) {
        let eva_crit_micro = this.evaluation_criteria_micros.find(
          (x) => x.id == this.selected_evaluation_criteria_micro
        );
        if (eva_crit_micro) {
          const matter = this.matterTrim || this.egressProfileMatterTrim;
          return this.$t("reusable.aiComponent.questionPrompt", {
            subjectEntity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
            subject: matter,
            indicatorEntity: this.$getVisibleNames(
              "teaching.evaluationcriteriamicro",
              false,
              "Indicador de Logro"
            ),
            indicator: eva_crit_micro.full_sentence,
            evaluationEntity: this.$getVisibleNames(
              "evaluations2.evaluation",
              false,
              "Evaluación"
            ),
            context: this.text_area,
          });
        }
      }
      if (this.sub_option == 4) {
        let content = this.studyUnitOptions.find(
          (x) => x.id == this.selected_study_unit
        );
        if (content) {
          const matter = this.matterTrim || this.egressProfileMatterTrim;
          return this.$t("reusable.aiComponent.contentPrompt", {
            subjectEntity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "asignatura"
            ),
            subject: matter,
            learningOutcomeEntity: this.$getVisibleNames(
              "teaching.ramicro",
              false,
              "Resultado de Aprendizaje"
            ),
            learningOutcome: content.full_sentence,
            amount: this.selected_example_amount,
          });
        }
      }
      if (this.sub_option == 5) {
        let competence = this.competenceOptions.find(
          (x) => x.id == this.selected_competence
        );
        let cycle = this.cycleOptions.find((x) => x.id == this.selected_cycle);

        if (competence && cycle) {
          const competencePluralSingular =
            this.selected_example_amount > 1
              ? this.$getVisibleNames("mesh.competence", true, "competencias")
              : this.$getVisibleNames("mesh.competence", false, "competencia");

          return this.$t("reusable.aiComponent.competenceCyclePrompt", {
            egressProfileEntity: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
            egressProfileName: this.egressProfile.name,
            competenceEntity: this.$getVisibleNames(
              "mesh.competence",
              false,
              "Competencia"
            ),
            competence: competence.full_sentence,
            cycleEntity: this.$getVisibleNames("mesh.cycle", false, "ciclo"),
            cycleName: cycle.name,
            text: competencePluralSingular,
            cycleActual: this.name_cycle_actual,
          });
        }
      }
      if (this.sub_option == 6) {
        let biblio_resource = this.bibliographic_resources_types.find(
          (x) => x.id == this.selected_bibliographic_resources
        );
        if (biblio_resource) {
          const matter = this.matterTrim || this.egressProfileMatterTrim;
          let biblio_format = this.bibliographicFormatOptions.find(
            (x) => x.id == this.selected_bibliographic_format
          );
          let formatText = biblio_format ? biblio_format.name : "APA";
          return this.$t("reusable.aiComponent.bibliographyPrompt", {
            subjectEntity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
            subject: matter,
            bibliographyName: biblio_resource.name,
            format: formatText,
          });
        }
      }
    },
    disableAiComponent() {
      if (this.user && this.user.user_data != null) {
        this.user.user_data.ai_component = false;
        this.$store.commit("setUser", this.user);
      } else if (this.user && this.user.user_data == null) {
        this.$store.dispatch("fetchMe");
      }
      this.$swal.fire({
        title: this.$t("reusable.aiComponent.aiAccessBlocked"),
        text: this.$t("reusable.aiComponent.inappropriateUseDetected"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("reusable.aiComponent.accept"),
        cancelButtonText: this.$t("reusable.common.close"),
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
    async generateExamples() {
      // Emitir evento para cambiar al tab de resultados
      this.$emit("change-tab", 1);

      this.disabled_button_generate = true;

      // Variables locales temporales para el streaming
      let result_examples = [];
      let error_message = null;

      // Emitir estado de carga inicial y limpiar resultados anteriores
      this.$emit("update-results", {
        examples: [],
        loading: true,
        error: null,
      });

      let payload = {};
      if (this.selected_egress_profile)
        payload.egress_profile = this.selected_egress_profile;
      if (this.selected_egress_profile_matter)
        payload.egress_profile_matter = this.selected_egress_profile_matter;
      if (this.selected_competence_unit)
        payload.competence_unit = this.selected_competence_unit;
      if (this.selected_study_unit)
        payload.study_unit = this.selected_study_unit;
      if (this.text_area && this.selected_intelligence_option == 7)
        payload.text_area = this.text_area;
      if (this.extra_context && this.selected_intelligence_option == 7)
        payload.extra_context = this.extra_context;
      if (this.selected_intelligence_option)
        payload.inteligence_option = this.selected_intelligence_option;
      if (this.selected_example_amount)
        payload.number_example = this.selected_example_amount;
      if (this.tokens_value) payload.max_tokens = this.tokens_value;
      if (this.temperature_value) payload.temperature = this.temperature_value;
      if (this.matter_id && this.selected_intelligence_option == 7)
        payload.matter = this.matter_id;
      if (this.selected_intelligence_option == 8) {
        const promptRubricAchievement = this.promptRubricAchievement();
        if (promptRubricAchievement == null) return;
        else payload.frontend_prompt = promptRubricAchievement;
      }

      try {
        // Hacer la petición con fetch para soportar streaming
        const response = await fetch(`${URL}/common/assessment-builder-ai/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt_token}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let fullContent = "";
        let finishReason = null;
        let streaming = true;

        while (streaming) {
          const { done, value } = await reader.read();

          if (done) {
            streaming = false;
            break;
          }

          const chunk = decoder.decode(value);
          const lines = chunk.split("\n");

          for (const line of lines) {
            if (line.startsWith("data: ")) {
              try {
                const jsonData = JSON.parse(line.slice(6));

                if (jsonData.error) {
                  error_message = jsonData.error;
                  streaming = false;
                  break;
                }

                if (jsonData.done) {
                  finishReason = jsonData.finish_reason;
                  streaming = false;
                  break;
                } else {
                  // Agregar el contenido en tiempo real
                  fullContent += jsonData.content;
                  // Actualizar result_examples en tiempo real
                  result_examples = fullContent
                    .split(/\n{1,}/)
                    .filter((part) => part.trim() !== "");

                  // Emitir resultados en tiempo real
                  this.$emit("update-results", {
                    examples: result_examples,
                    loading: true,
                    error: null,
                  });
                }
              } catch (e) {
                console.error("Error parsing JSON:", e);
              }
            }
          }
        }

        this.disabled_button_generate = false;

        // Manejo de `finish_reason`
        switch (finishReason) {
          case "length":
            error_message = this.$t("reusable.aiComponent.lengthLimitReached");
            break;
          case "null":
            error_message = this.$t(
              "reusable.aiComponent.couldNotDetermineResult"
            );
            break;
          case "content_filter":
            error_message = this.$t("reusable.aiComponent.contentFilterError");
            this.disableAiComponent();
            break;
          default:
            error_message = null;
        }

        // Emitir resultados finales
        this.$emit("update-results", {
          examples: result_examples,
          loading: false,
          error: error_message,
        });

        // PASO 6: Agregar al store los nuevos valores
        // Uso del Local Storage
        // Parameters AI
        this.$store.commit("setLocalVariable", {
          component: this.$route.name,
          variable: this.urlLocalStorage(),
          value: {
            egress_profile: this.selected_egress_profile,
            egress_profile_matter: this.selected_egress_profile_matter,
            competence_unit: this.selected_competence_unit,
            study_unit: this.selected_study_unit,
            intelligence_option: this.selected_intelligence_option,
            example_amount: this.selected_example_amount,
            temperature_value: this.temperature_value,
            tokens_value: this.tokens_value,
            result_examples: result_examples,
            rubric_criteria: this.selected_rubric_criteria,
            rubric_achievement: this.selected_rubric_achievement,
            evaluation_criteria_micro: this.selected_evaluation_criteria_micro,
            competence: this.selected_competence,
            cycle: this.selected_cycle,
            bibliographic_resources: this.selected_bibliographic_resources,
            bibliographic_format: this.selected_bibliographic_format,
          },
        });
      } catch (error) {
        console.error("Error en generateExamples:", error);
        this.disabled_button_generate = false;

        error_message = this.$t(
          "reusable.aiComponent.serverCommunicationError"
        );
        result_examples = [this.$t("reusable.aiComponent.generationError")];

        // Emitir error
        this.$emit("update-results", {
          examples: result_examples,
          loading: false,
          error: error_message,
        });
      }
    },
    // PASO 7: Agregar a la url del store la nueva opción
    urlLocalStorage() {
      let arr = [];
      // Opción generar Competencia
      if (this.selected_intelligence_option == 1) {
        arr.push(`competence=ep-${this.selected_egress_profile}`);
      }
      // Opción generar Unidad de Estudio
      if (this.selected_intelligence_option == 2) {
        if (
          this.institution &&
          this.institution.internal_use_id != "duoc.cl" &&
          this.institution.show_competence_unit == false
        ) {
          arr.push(
            `study_unit=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}`
          );
        }
        if (this.institution && this.institution.internal_use_id == "duoc.cl") {
          arr.push(
            `study_unit=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}`
          );
        }
        if (this.institution && this.institution.show_competence_unit) {
          arr.push(
            `study_unit=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}&cu-${this.selected_competence_unit}`
          );
        }
      }
      // Opción generar Indicador de Logro
      if (this.selected_intelligence_option == 3) {
        if (
          this.institution &&
          this.institution.internal_use_id != "duoc.cl" &&
          this.institution.show_competence_unit == false
        ) {
          arr.push(
            `evaluation_criteria_micro=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}&su-${this.selected_study_unit}`
          );
        }
        if (this.institution && this.institution.internal_use_id == "duoc.cl") {
          arr.push(
            `evaluation_criteria_micro=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}&su-${this.selected_study_unit}`
          );
        }
        if (this.institution && this.institution.show_competence_unit) {
          arr.push(
            `evaluation_criteria_micro=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}&cu-${this.selected_competence_unit}`
          );
        }
      }
      // Opción generar Unidad de Competencia (IPSS)
      if (this.selected_intelligence_option == 4) {
        arr.push(
          `competence_unit=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}`
        );
      }
      // Opción generar RA Macro
      if (this.selected_intelligence_option == 5) {
        arr.push(
          `ra_macro=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}`
        );
      }
      // Opción generar Evaluation Criteria Macro
      if (this.selected_intelligence_option == 6) {
        arr.push(
          `evaluation_criteria_macro=ep-${this.selected_egress_profile}&epm-${this.selected_egress_profile_matter}`
        );
      }
      // Opción Generica
      if (this.selected_intelligence_option == 8) {
        if (this.sub_option == 1) {
          arr.push(
            `rubric_achievement=rc-${this.selected_rubric_criteria}&rachv-${this.selected_rubric_achievement}`
          );
        }
        if (this.sub_option == 2) {
          arr.push(`dimension=ecm-${this.selected_evaluation_criteria_micro}`);
        }
        if (this.sub_option == 3) {
          arr.push(`question=ecm-${this.selected_evaluation_criteria_micro}`);
        }
        if (this.sub_option == 4) {
          arr.push(`content=su-${this.selected_study_unit}`);
        }
        if (this.sub_option == 5) {
          arr.push(
            `competence_per_cycle=comp-${this.selected_competence}&cy-${this.selected_cycle}`
          );
        }
        if (this.sub_option == 6) {
          arr.push(
            `bibliographic_resources=bibl-${this.selected_bibliographic_resources}&bf-${this.selected_bibliographic_format}`
          );
        }
      }
      const url = `${arr.join("&")}`;
      return url;
    },
    updateTokens() {
      if (this.selected_example_amount == 1) {
        this.tokens_value = 220;
      } else if (this.selected_example_amount == 2) {
        this.tokens_value = 300;
      } else if (this.selected_example_amount == 3) {
        this.tokens_value = 380;
      } else if (this.selected_example_amount == 4) {
        this.tokens_value = 450;
      } else if (this.selected_example_amount == 5) {
        this.tokens_value = 530;
      }
    },
    clearInfoSelector() {
      if (this.selected_intelligence_option == 1) {
        this.selected_egress_profile_matter = null;
        this.selected_study_unit = null;
      }
      if (this.selected_intelligence_option == 2) {
        this.selected_study_unit = null;
      }
    },
    fetchEgressProfile() {
      this.selected_egress_profile_matter = null;
      this.selected_study_unit = null;
      if (this.selected_egress_profile) {
        this.$store.dispatch(names.FETCH_MATTERS, {
          egress_profile_id: this.selected_egress_profile,
        });
        this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
          egress_profile_id: this.selected_egress_profile,
        });
      }
    },
    fetchStudyUnit() {
      this.selected_study_unit = null;
      if (this.selected_egress_profile_matter) {
        const matter = this.egress_profile_matters.find(
          (x) => x.id == this.selected_egress_profile_matter
        );
        if (matter) {
          this.$store.dispatch(names.FETCH_STUDY_UNITS, matter.matter);
        }
      }
    },
  },
  watch: {
    // PASO 8: Agregar la opcion a un caso para el recibir MUTATE de la vista
    filter_intelligence(value) {
      // Emitir evento para cambiar al tab de configuración (tab 0)
      this.$emit("change-tab", 0);
      if (value) {
        // Flujo normal cuando recibe valores desde los componentes mediante los "MUTATE"
        switch (value.intelligence_option) {
          case 1: // Opcion 1: Competencia
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            break;
          case 2: // Opcion 2: Unidad de Estudio
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            this.selected_competence_unit = value.competence_unit_id;
            break;
          case 3: // Opcion 3: Indicador de Logro
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            this.selected_competence_unit = value.competence_unit_id;
            this.selected_study_unit = value.study_unit_id;
            break;
          case 4: // Opcion 4: Unidad de Competencia (IPSS)
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            break;
          case 5: // Opcion 5: Resultado de Aprendizaje General
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            break;
          case 6: // Opcion 6: Indicador de Logro General
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            break;
          case 7: // Opcion 7: Opción Libre
            this.selected_intelligence_option = value.intelligence_option;
            this.selected_egress_profile = value.egress_profile_id;
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            this.matter_id = value.matter_id;
            this.extra_context = value.extra_context;
            if (value.show_message_evaluation_view == true) {
              this.show_message_evaluation_view =
                value.show_message_evaluation_view;
            }
            this.extra_context = value.extra_context;
            break;
          case 8: // Opcion 8: Nivel de Logro
            this.selected_intelligence_option = value.intelligence_option;
            this.extra_label = value.extra_label;
            this.sub_option = value.sub_option;
            // Variables de los Niveles de Logro
            this.selected_rubric_criteria = value.rubric_criteria_id;
            this.selected_rubric_achievement = value.rubric_achievement_id;
            // Dimensiones Rubrica
            this.selected_evaluation_criteria_micro =
              value.evaluation_criteria_micro;
            this.available_evaluation_criteria_micro =
              value.available_evaluation_criteria_micro;
            this.matter_id = value.matter_id;
            if (value.show_message_evaluation_view == true) {
              this.show_message_evaluation_view =
                value.show_message_evaluation_view;
            }
            // Contenidos del PMD
            this.selected_egress_profile_matter =
              value.egress_profile_matter_id;
            this.selected_study_unit = value.study_unit_id;
            // Variables de la Matriz 1
            this.selected_egress_profile = value.egress_profile_id;
            this.order_last_competence = value.order;
            this.order_last_cycle = value.cycle_order;
            this.selected_cycle = value.cycle_id;
            this.selected_competence = value.competence_id;
            this.name_cycle_actual = value.name_cycle_actual;
            // Recursos Bibliograficos
            this.selected_bibliographic_resources =
              value.bibliographic_resources;
            this.selected_bibliographic_format = value.bibliographic_format;
        }

        const parameters_ai = this.$store.getters.getLocalVariable(
          this.$route.name,
          this.urlLocalStorage()
        );
        // PASO 9: Agregar la opcion para actualizar los valores en el LocalStorage
        // Valores del LocalStorage
        if (this.parameter_local_storage == false && parameters_ai) {
          this.parameter_local_storage = true;

          // Solo actualiza si son diferentes a los valores en LocalStorage
          if (parameters_ai.egress_profile != this.selected_egress_profile) {
            this.selected_egress_profile = parameters_ai.egress_profile;
          }
          if (
            parameters_ai.egress_profile_matter !=
            this.selected_egress_profile_matter
          ) {
            this.selected_egress_profile_matter =
              parameters_ai.egress_profile_matter;
          }
          if (parameters_ai.competence_unit != this.selected_competence_unit) {
            this.selected_competence_unit = parameters_ai.competence_unit;
          }
          if (parameters_ai.study_unit != this.selected_study_unit) {
            this.selected_study_unit = parameters_ai.study_unit;
          }
          if (
            parameters_ai.intelligence_option !=
            this.selected_intelligence_option
          ) {
            this.selected_intelligence_option =
              parameters_ai.intelligence_option;
          }
          if (parameters_ai.rubric_criteria != this.selected_rubric_criteria) {
            this.selected_rubric_criteria = parameters_ai.rubric_criteria;
          }
          if (
            parameters_ai.rubric_achievement != this.selected_rubric_achievement
          ) {
            this.selected_rubric_achievement = parameters_ai.rubric_achievement;
          }
          if (
            parameters_ai.evaluation_criteria_micro !=
            this.selected_evaluation_criteria_micro
          ) {
            this.selected_evaluation_criteria_micro =
              parameters_ai.evaluation_criteria_micro;
          }
          if (
            parameters_ai.selected_bibliographic_resources !=
            this.selected_bibliographic_resources
          ) {
            this.selected_bibliographic_resources =
              parameters_ai.bibliographic_resources;
          }
          if (
            parameters_ai.bibliographic_format !=
            this.selected_bibliographic_format
          ) {
            this.selected_bibliographic_format =
              parameters_ai.bibliographic_format;
          }
          if (parameters_ai.cycle != this.selected_cycle) {
            this.selected_cycle = parameters_ai.cycle;
          }
          if (parameters_ai.competence != this.selected_competence) {
            this.selected_competence = parameters_ai.competence;
          }
          this.selected_example_amount = Number(parameters_ai.example_amount);
          this.temperature_value = parseFloat(parameters_ai.temperature_value);
          this.tokens_value = parseInt(parameters_ai.tokens_value);
          // Emitir resultados guardados del localStorage
          if (parameters_ai.result_examples) {
            this.$emit("update-results", {
              examples: parameters_ai.result_examples,
              loading: false,
              error: null,
            });
          }
        }
      }
      // PASO 10: Resetar valores a null
      // Resetea valores cuando `filter_intelligence` es null
      if (value == null) {
        this.selected_intelligence_option = null;
        this.selected_egress_profile = null;
        this.selected_egress_profile_matter = null;
        this.selected_competence_unit = null;
        this.selected_study_unit = null;
        this.selected_rubric_criteria = null;
        this.selected_rubric_achievement = null;
        this.selected_evaluation_criteria_micro = null;
        this.selected_bibliographic_resources = null;
        this.selected_bibliographic_format = null;
        this.selected_competence = null;
        this.selected_cycle = null;
        this.matter_id = null;
        this.parameter_local_storage = false;
        this.show_message_evaluation_view = false;
        this.extra_context = "";
        this.extra_label = "";
        this.sub_option = 0;
      }
    },
    // PASO 11: Deshabilitar la opción
    rules_filter_selector(value) {
      if (value) {
        if (value.disabled_selected_intelligence_option) {
          this.disabled_selected_intelligence_option =
            value.disabled_selected_intelligence_option;
        }
        if (value.disabled_selected_egress_profile) {
          this.disabled_selected_egress_profile =
            value.disabled_selected_egress_profile;
        }
        if (value.disabled_selected_egress_profile_matter) {
          this.disabled_selected_egress_profile_matter =
            value.disabled_selected_egress_profile_matter;
        }
        if (value.disabled_selected_competence_unit) {
          this.disabled_selected_competence_unit =
            value.disabled_selected_competence_unit;
        }
        if (value.disabled_selected_study_unit) {
          this.disabled_selected_study_unit =
            value.disabled_selected_study_unit;
        }
        if (value.disabled_text_area) {
          this.disabled_text_area = value.disabled_text_area;
        }
        if (value.disabled_selected_rubric_criteria) {
          this.disabled_selected_rubric_criteria =
            value.disabled_selected_rubric_criteria;
        }
        if (value.disabled_selected_rubric_achievement) {
          this.disabled_selected_rubric_achievement =
            value.disabled_selected_rubric_achievement;
        }
        if (value.disabled_selected_evaluation_criteria_micro) {
          this.disabled_selected_evaluation_criteria_micro =
            value.disabled_selected_evaluation_criteria_micro;
        }
        if (value.disabled_selected_bibliographic_resources) {
          this.disabled_selected_bibliographic_resources =
            value.disabled_selected_bibliographic_resources;
        }
        if (value.disabled_selected_bibliographic_format) {
          this.disabled_selected_bibliographic_format =
            value.disabled_selected_bibliographic_format;
        }
      }
      // PASO 12: Establecer el valor en false
      if (value == null) {
        this.disabled_selected_intelligence_option = false;
        this.disabled_selected_egress_profile = false;
        this.disabled_selected_egress_profile_matter = false;
        this.disabled_selected_competence_unit = false;
        this.disabled_selected_study_unit = false;
        this.disabled_selected_rubric_criteria = false;
        this.disabled_selected_rubric_achievement = false;
        this.disabled_selected_evaluation_criteria_micro = false;
        this.disabled_selected_bibliographic_resources = false;
        this.disabled_selected_bibliographic_format = false;
        this.disabled_text_area = false;
      }
    },
  },
  mounted() {
    // Uso del Local Storage
    // Parameters AI
    const parameters_ai = this.$store.getters.getLocalVariable(
      this.$route.name,
      this.urlLocalStorage()
    );

    // PASO 13: Establecer la nueva opcion en el local storage cuando se monta
    if (parameters_ai) {
      this.parameter_local_storage = true;
      this.selected_egress_profile = parameters_ai.egress_profile;
      this.selected_egress_profile_matter = parameters_ai.egress_profile_matter;
      this.selected_competence_unit = parameters_ai.competence_unit;
      this.selected_study_unit = parameters_ai.study_unit;
      this.selected_rubric_criteria = parameters_ai.rubric_criteria;
      this.selected_rubric_achievement = parameters_ai.rubric_achievement;
      this.selected_evaluation_criteria_micro =
        parameters_ai.evaluation_criteria_micro;
      this.selected_bibliographic_resources =
        parameters_ai.bibliographic_resources;
      this.selected_bibliographic_format = parameters_ai.bibliographic_format;
      this.selected_competence = parameters_ai.competence;
      this.selected_cycle = parameters_ai.cycle;
      this.selected_intelligence_option = parameters_ai.intelligence_option;
      this.selected_example_amount = Number(parameters_ai.example_amount);
      this.temperature_value = parseFloat(parameters_ai.temperature_value);
      this.tokens_value = parseInt(parameters_ai.tokens_value);
      // Emit de resultados guardados del localStorage
      if (parameters_ai.result_examples) {
        this.$emit("update-results", {
          examples: parameters_ai.result_examples,
          loading: false,
          error: null,
        });
      }
    }
  },
  created() {},
};
</script>

<style scoped>
.card-options {
  font-family: var(--kl-font-family);
  color: var(--kl-text-body);
  background-color: var(--kl-card-bg);
  border: 1px solid var(--kl-card-border);
  box-shadow: var(--kl-card-shadow);
}
.card-options >>> .card-header {
  padding: var(--kl-space-2) var(--kl-space-3);
  background-color: var(--kl-color-accent-soft);
  border-bottom: 1px solid var(--kl-card-border);
}
.card-options >>> .card-header h4 {
  font-size: var(--kl-fs-title-sm);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-color-accent);
}
.card-options >>> .card-body {
  padding: 2px;
  min-height: 100%;
}
.card-options >>> .card-footer {
  background-color: transparent;
  border-top: 1px solid var(--kl-card-border);
}
.icon-settings {
  cursor: pointer;
  color: var(--kl-color-accent);
}
.body-card-container {
  max-height: 75vh;
  overflow-y: auto;
}
.custom-card-height {
  min-height: 30vh;
}
.container-checkbox-amount {
  display: flex;
  justify-content: space-evenly;
}
.pre-text-area {
  font-size: var(--kl-fs-small);
  color: var(--kl-text-muted);
}
</style>